import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserTournament } from '../user-tournament.model';

@JsonObject('UserTournamentsResultsResponse')
export class UserTournamentsResultsResponse extends ApiResultsResponse<UserTournament> {

  @JsonProperty('results', [UserTournament])
  override results: UserTournament[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
